import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import Button from 'components/common/Button';

const reloadPage = () => window.location.reload();

export default () => (
  <div className="container">
    <div className="loan-response">
      <div className="loan-response__icon">
        <span className="icon icon--clouds" />
      </div>
      <h1 className="loan-response__title">
        <FormattedHTMLMessage id="technical.error.title" />
      </h1>
      <p />
      <h3 className="loan-response__title-caption">
        <FormattedMessage id="technical.error.body" tagName="p" />
      </h3>
      <footer className="loan-response__footer">
        <Button
          type="button"
          onClick={reloadPage}
        >
          <FormattedMessage id="technical.error.retry" />
        </Button>
      </footer>
    </div>
  </div>
);
